
<app-landing-screen [backgroundImageUrl]="backgroundImageUrl">
    <section class="contents-container">
      <section class="contents">
        <section >
            <img
              class="home-page-logo"
              [src]="logoUrl"
            />
          </section>
        <section class="title">
          <h1  class="slogan">{{ messageHeading }} </h1>
          <p class="slogan">{{ messageSub }}</p>
        </section>
        <br />
      </section>
    </section>
  </app-landing-screen>
  